export default "__VITE_ASSET__C8J1mqUP__"